<template>
  <label class="form-checkbox">
    <!--Input-->
    <input
      ref="input"
      class="form-checkbox__input"
      :checked="value"
      type="checkbox"
      @input="onInput"
    >
    <div class="form-checkbox__icon" />

    <span class="form-checkbox__label" v-html="label" />

  </label>
</template>

<script>

  export default {
    name: 'BaseCheckbox',

    props: {
      value: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      }
    },

    computed: {

    },

    methods: {
      onInput (event) {
        this.$emit('input', event.target.checked)
      }
    }
  }
</script>

<style lang="scss">
.form-checkbox {
  position: relative;
  display: flex;

  &__label {
    display: flex;
    font-size: 14px;
    line-height: 1.34;

    a {
      font-size: 14px;
      line-height: 1.34;
      display: inline-block;
      margin-left: 5px;
      color: $c-yellow;
      transition: 0.3s;

      @include hover {
        text-decoration: none;
      }
    }
  }

  &__input {
    display: none;

    &:checked + .form-checkbox__icon {
      background-color: #FDE8CC;
      border-color: #FDE8CC;

      &::before {
        opacity: 1;
      }
    }
  }

  &__icon {
    position: relative;
    width: 16px;
    height: 16px;
    border: 2px solid #dbdbdb;
    margin-right: 14px;
    transition: 0.3s;

    &::before {
      position: absolute;
      top: 0px;
      left: 4px;
      width: 5px;
      height: 9px;
      border-right: 2px solid $c-orange;
      border-bottom: 2px solid $c-orange;
      opacity: 0;
      transition: 0.3s;
      content: '';
      transform: rotate(45deg);
    }
  }

    @include hover {
    .form-checkbox__icon {
      border-color: $c-yellow;
    }
  }
}
</style>
